// app/frontend/comopnents/MetaTagUpdater.ts
import { router } from '@inertiajs/react';

/**
 * Updates meta tags during Inertia navigation
 * Use this to ensure Open Graph and other meta tags are updated
 * when navigating between pages
 */
export function setupMetaUpdater() {
  // Listen for successful navigation events
  router.on('success', (event) => {
    const currentUrl = window.location.href;
    // console.log('🔄 Updating meta tags for URL:', currentUrl);

    // Update og:url meta tag
    updateMetaTag('og:url', currentUrl);

    // Update canonical link if it exists
    updateCanonicalLink(currentUrl);

    // Additional meta updates based on page properties can be added here
    // You can access page props from the event if needed
    const pageProps = event.detail.page.props;

    // Update title if available in props
    if (pageProps.metaTitle) {
      if (typeof pageProps.metaTitle === 'string') {
        document.title = pageProps.metaTitle;
        updateMetaTag('og:title', pageProps.metaTitle);
      }
    }

    // Update description if available in props
    if (pageProps.metaDescription && typeof pageProps.metaDescription === 'string') {
      updateMetaTag('og:description', pageProps.metaDescription);
    }

    // Update image if available in props
    if (pageProps.metaImage && typeof pageProps.metaImage === 'string') {
      updateMetaTag('og:image', pageProps.metaImage);
    }

    // Force update browser history state as a backup
    history.replaceState({ ...history.state }, document.title, currentUrl);
  });
}

/**
 * Updates a specific meta tag with a new value
 */
function updateMetaTag(property: string, content: string) {
  // Find meta tag with property attribute
  let metaTag = document.querySelector(`meta[property="${property}"]`);

  // If it doesn't exist, check for name attribute as fallback
  if (!metaTag) {
    metaTag = document.querySelector(`meta[name="${property}"]`);
  }

  // If the meta tag exists, update it
  if (metaTag) {
    metaTag.setAttribute('content', content);
    // console.log(`✅ Updated meta ${property} to: ${content}`);
  } else {
    // If the meta tag doesn't exist, create it
    metaTag = document.createElement('meta');
    metaTag.setAttribute('property', property);
    metaTag.setAttribute('content', content);
    document.head.appendChild(metaTag);
    // console.log(`✅ Created meta ${property} with: ${content}`);
  }
}

/**
 * Updates the canonical link element
 */
function updateCanonicalLink(url: string) {
  let canonicalLink = document.querySelector('link[rel="canonical"]');

  if (canonicalLink) {
    canonicalLink.setAttribute('href', url);
    // console.log(`✅ Updated canonical link to: ${url}`);
  } else {
    canonicalLink = document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute('href', url);
    document.head.appendChild(canonicalLink);
    // console.log(`✅ Created canonical link with: ${url}`);
  }
}
